import { ReactNode } from "react";
import { X } from "lucide-react";

type ChipProps = {
    children: ReactNode;
    onClose?(): void;
    color?: string;
}

export const Chip = ({...props}: ChipProps) => (
  <span className="inline-flex h-7 items-center gap-1 rounded-full border bg-background pl-3 pr-1 text-xs text-foreground">
    <span className={props.onClose ? undefined : "pr-2"}>{props.children}</span>
    {props.onClose && (
      <button
        type="button"
        onClick={props.onClose}
        aria-label="Remover filtro"
        className="flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <X className="h-3 w-3" />
      </button>
    )}
  </span>
)
